import { observable, action } from "mobx";

const Store = observable(
  {
    query: "",
    advancedFilter: false,
    page: 0,
    searchValues: {
      email: "",
      elderly_name: "",
      counties: "",
      districts: "",
      min_price: "",
      max_price: "",
      request_since: null,
      request_date: null,
      request_until: null,
      request_state: "",
      request_type: "",
      request_period: "",
      visited_since: null,
      proposed_visit_date_since: null,
      proposed_admission_date_since: null,
      is_urgent: null,
      admin_id: "",
      entity: "",
      establishment_valence: "",
      payed_subscription: null,
    },

    userRequests: [],

    count: 0,

    toggleAdvancedFilter() {
      this.advancedFilter = !this.advancedFilter;
    },

    setPage(page) {
      this.page = page;
    },

    setQuery(query) {
      console.log(this.query, query);
      this.query = query;
    },

    setSearchValues(vals) {
      this.searchValues = vals;
    },

    setCount(count) {
      this.count = count;
    },

    setUserRequests(userRequests) {
      this.userRequests = userRequests;
    },
  },
  {
    toggleAdvancedFilter: action,
    setPage: action,
    setQuery: action,
    setCount: action,
    setUserRequests: action,
    setSearchValues: action,
  }
);

export default Store;
